import { render } from "./ShoppingListCreator.vue?vue&type=template&id=6f645e9c&scoped=true"
import script from "./ShoppingListCreator.vue?vue&type=script&lang=js"
export * from "./ShoppingListCreator.vue?vue&type=script&lang=js"

import "./ShoppingListCreator.vue?vue&type=style&index=0&id=6f645e9c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f645e9c"]])

export default __exports__